import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';
import Crypto from './crypto';


function App() {
  return (
    <div className="App">
      <Crypto />
    </div>
  );
}

export default App;
